import styled from '@emotion/styled';
import { Button, SpaceDivider, Text } from '@innovationdepartment/proxima-ui';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';

type JoinConfirmationViewProps = {
  confirm: () => void;
  close: () => void;
  brandName: string;
  isLoading?: boolean;
};

const ButtonGroup = styled.div`
  display: inline-flex;
  justify-content: end;
  width: 100%;
  button:first-of-type {
    margin-right: 1rem;
  }
`;

const Container = styled.div`
  padding: 24px;
`;

const JoinConfirmationView = ({
  confirm,
  close,
  brandName,
  isLoading
}: JoinConfirmationViewProps) => (
  <>
    <Container>
      <SpaceDivider y={2} />
      <Text>
        Are you sure you want to add yourself to brand{' '}
        <Text color="neutral100" variant="body1Semibold">
          {brandName}
        </Text>
        ? You&apos;ll be granted admin access.
      </Text>
    </Container>
    <SpaceDivider y={4} />
    <ButtonGroup>
      <Button size="small" variant="outlined" label="Back" onClick={close} disabled={isLoading} />
      <Button
        size="small"
        startIcon={<PersonAddOutlinedIcon />}
        label="Add me"
        onClick={confirm}
        disabled={isLoading}
      />
    </ButtonGroup>
  </>
);

export default JoinConfirmationView;
